import { render, staticRenderFns } from "./BaseInputNumber.vue?vue&type=template&id=480eac26&scoped=true"
import script from "./BaseInputNumber.vue?vue&type=script&lang=js"
export * from "./BaseInputNumber.vue?vue&type=script&lang=js"
import style0 from "./BaseInputNumber.vue?vue&type=style&index=0&id=480eac26&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480eac26",
  null
  
)

export default component.exports